/**
 * LAS REGLAS DE LAS FINALS, EXPLICADAS.
 *
 * POR QUÉ EXISTE. Las Finals son el único formato con reglas que no se
 * adivinan mirando el cuadro. Que se entre por invitación y en tandas, que el
 * cupo pase al siguiente del ranking cuando alguien no contesta, y —sobre
 * todo— que el desempate no sea el de siempre: en el resto de la aplicación
 * manda «yo te gané», y acá manda haber jugado más partidos. Alguien que mira
 * la tabla y ve segundo a quien le ganó a todos merece leer por qué, sin
 * tener que preguntarle al club.
 *
 * VIVE EN SU PROPIO COMPONENTE porque se muestra en DOS lugares que no se
 * parecen: el torneo —donde quien ya está adentro mira la tabla— y la
 * invitación —donde alguien decide si acepta—. Es la misma explicación y
 * tiene que decir lo mismo en los dos: dos copias se contradicen el día que
 * alguien corrige una sola.
 *
 * LOS PLAZOS ENTRAN POR PARÁMETRO y no están escritos en el texto. Son
 * configurables por categoría —7/3/2 es el valor de fábrica, no una regla— y
 * un texto que dijera «siete días» mentiría en el club que los puso en diez.
 *
 * SE PUEDE PLEGAR. Son ocho frases: útiles la primera vez y estorbo la
 * décima. Abierto de entrada en la invitación —ahí es justo lo que hay que
 * leer antes de contestar— y plegado en el torneo, donde lo que se viene a
 * ver es la tabla.
 */
import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function FinalsRules({
  first,
  second,
  rest,
  defaultOpen = false,
}: {
  first: number;
  second: number;
  rest: number;
  defaultOpen?: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  const [abierto, setAbierto] = useState(defaultOpen);
  const id = useId();

  return (
    <section className="finals-rules">
      <button
        type="button"
        className="link finals-rules-toggle"
        aria-expanded={abierto}
        aria-controls={id}
        onClick={() => setAbierto((v) => !v)}
      >
        {t('finals.title')}
      </button>

      <div id={id} hidden={!abierto}>
        <ul className="finals-rules-list">
          <li>{t('finals.who')}</li>
          <li>{t('finals.invites', { first, second, rest })}</li>
          <li>{t('finals.groups')}</li>
          <li>{t('finals.playoff')}</li>
          <li>{t('finals.note')}</li>
        </ul>

        <h4 className="finals-rules-subtitle">{t('finals.tiebreakTitle')}</h4>
        {/*
          NUMERADA Y EN ESTE ORDEN, porque el orden ES la regla: se baja al
          siguiente criterio solo cuando el anterior no alcanzó. Una lista con
          viñetas los leería como cinco cosas sueltas.
        */}
        <ol className="finals-rules-tiebreak">
          <li>{t('finals.tiebreak1')}</li>
          <li>{t('finals.tiebreak2')}</li>
          <li>{t('finals.tiebreak3')}</li>
          <li>{t('finals.tiebreak4')}</li>
          <li>{t('finals.tiebreak5')}</li>
        </ol>
      </div>
    </section>
  );
}
